import styled from 'styled-components';
import { THEME_BLACK, THEME_GREY, themeColor } from '../../../styles/basics/colors';

export const StProductListCell = styled.div`
    padding: 0;
    vertical-align: top;
    position: relative;
    box-sizing: border-box;
    color: ${themeColor(THEME_BLACK)};
    line-height: 16px;
    width: 100%;
`;

export const StButtonV2 = styled.div`
    padding: 0 0 5px 0;
    width: 240px;
    z-index: 1;
`;

export const StCellBottom = styled.div`
    bottom: 15px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    line-height: 16px;
`;

export const StBadges = styled.div`
    flex-shrink: 0;
    position: relative;
`;

export const StCampaignDates = styled.div`
    flex-grow: 1;
    margin: 0 5px;
`;

export const StButtonPos = styled.div``;

export const StActions = styled.div`
    z-index: auto;
    position: relative;
    width: 100%;
    min-width: 230px;
    float: right;
    padding-bottom: 15px;
`;

export const StActionButtons = styled.div`
    z-index: 3;
    box-sizing: border-box;
    color: #000000;
    display: table-cell;
    line-height: 16px;
    padding: 10px 0 8px 0;
    vertical-align: top;
    width: 100%;
    float: right;
    .default-dd-nav.dd-w-select {
        width: initial;
        min-width: 212px;
    }
    .bt-bordered {
        width: 100%;
    }
`;

export const StCoverGraying = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #ffffff;
    opacity: 0.5;
`;

StCoverGraying.displayName = 'ListItem__StCoverGraying';

export const StBadgeGraying = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: #ffffff;
    opacity: 0.5;
`;

StBadgeGraying.displayName = 'ListItem__StBadgeGraying';

export const StTextGraying = styled.div`
    * {
        color: ${themeColor(THEME_GREY)} !important;
    }
`;

StTextGraying.displayName = 'ListItem__StTextGraying';

export const StProductUnavailable = styled.strong`
    color: ${themeColor(THEME_GREY)};
`;
